import React from "react";
import ImageModal from "../../components/ImageModal";

const ChallengeAndSolution = ({ casedata }) => {
  const hasResults = !!casedata?.resultlist?.length;
  const hasConclusion = !!casedata?.conclusion?.length;

  return (
    <>
      {/* <img
        style={{
          width: "101%",
          height: "27rem",
          margin: "63px 0",
          padding: "0 100px",
        }}
        src="/images/ff.png"
        alt=""
      /> */}

      <div className="cands">
        <header className="cs-header">
          <h2 className="cs-header__title">Case study breakdown</h2>
          <nav className="cs-jump" aria-label="Jump to section">
            <a className="cs-jump__link" href="#features">
              Features
            </a>
            <a className="cs-jump__link" href="#challenges">
              Challenges
            </a>
            <a className="cs-jump__link" href="#solution">
              Solution
            </a>
            {hasResults && (
              <a className="cs-jump__link" href="#results">
                Results
              </a>
            )}
            {hasConclusion && (
              <a className="cs-jump__link" href="#conclusion">
                Conclusion
              </a>
            )}
          </nav>
        </header>

        <section id="features" className="cs-section cs-section--feature">
          <div className="cs-section__media">
            <ImageModal src="/images/d1 (2).png" alt="Features illustration">
              <img
                src="/images/d1 (2).png"
                alt="Features illustration"
                loading="lazy"
              />
            </ImageModal>
          </div>
          <div className="cs-section__content">
            <h3>Features</h3>
            <ul className="cs-list">
              {casedata?.Feature?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section id="challenges" className="cs-section cs-section--challenge">
          <div className="cs-section__media">
            <ImageModal src="/images/d2.png" alt="Challenges illustration">
              <img src="/images/d2.png" alt="Challenges illustration" loading="lazy" />
            </ImageModal>
          </div>
          <div className="cs-section__content">
            <h3>Challenges</h3>
            <ul className="cs-list">
              {casedata?.listchallenge?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section id="solution" className="cs-section cs-section--solution">
          <div className="cs-section__media">
            <ImageModal src="/images/image.png" alt="Solution illustration">
              <img src="/images/image.png" alt="Solution illustration" loading="lazy" />
            </ImageModal>
          </div>
          <div className="cs-section__content">
            <h3>Solution</h3>
            <ul className="cs-list">
              {casedata?.listsolution?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        {hasResults && (
          <section id="results" className="cs-section cs-section--results">
            <div className="cs-section__media">
              <ImageModal src="/images/d3.png" alt="Results illustration">
                <img src="/images/d3.png" alt="Results illustration" loading="lazy" />
              </ImageModal>
            </div>
            <div className="cs-section__content">
              <h3>Results</h3>
              <ul className="cs-list">
                {casedata?.resultlist?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        )}

        {hasConclusion && (
          <section id="conclusion" className="cs-section cs-section--conclusion">
            <div className="cs-section__media">
              <ImageModal src="/images/d4.png" alt="Conclusion illustration">
                <img src="/images/d4.png" alt="Conclusion illustration" loading="lazy" />
              </ImageModal>
            </div>
            <div className="cs-section__content">
              <h3>Conclusion</h3>
              <ul className="cs-list">
                {casedata?.conclusion?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        )}
      </div>
    </>
  );
};
export default ChallengeAndSolution;
